import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ActivitiesApiAdapter } from '../adapters/ActivitiesApiAdapter';
import type { OrderActivities } from '../models/Activities';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ActivitiesApiAdapter(httpClient);

export const useOrderActivities = () => {
  const { orderId } = useParams<{ orderId: string }>();

  return useQuery<OrderActivities | undefined>({
    queryKey: ['orderActivities', orderId],
    queryFn: async () => {
      if (!orderId) return undefined;
      return adapter.getOrderActivities(Number(orderId));
    },
    enabled: Boolean(orderId),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });
};
